import React, { useState } from 'react';
import { CalendarIcon } from 'lucide-react';
import { format } from 'date-fns';
interface DateRange {
  start: string;
  end: string;
}
interface DateRangePickerProps {
  value: DateRange;
  onChange: (value: DateRange) => void;
}
const DateRangePicker: React.FC<DateRangePickerProps> = ({
  value,
  onChange
}) => {
  // Format the display date in DD MMM YYYY format
  const formatDisplayDate = (dateString: string) => {
    if (!dateString) return '';
    try {
      return format(new Date(dateString), 'dd MMM yyyy');
    } catch (e) {
      return '';
    }
  };
  const handleStartDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange({
      ...value,
      start: e.target.value
    });
  };
  const handleEndDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange({
      ...value,
      end: e.target.value
    });
  };
  return <div className="flex space-x-2 items-center" data-id="element-18">
      <div className="relative flex-1" data-id="element-19">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-20">
          <CalendarIcon className="h-4 w-4 text-gray-400" data-id="element-21" />
        </div>
        <input type="date" className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-blue-500 focus:border-blue-500 sm:text-sm" value={value.start} onChange={handleStartDateChange} aria-label="Start date" data-id="element-22" />
      </div>
      <span className="text-gray-500" data-id="element-23">to</span>
      <div className="relative flex-1" data-id="element-24">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-25">
          <CalendarIcon className="h-4 w-4 text-gray-400" data-id="element-26" />
        </div>
        <input type="date" className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-blue-500 focus:border-blue-500 sm:text-sm" value={value.end} onChange={handleEndDateChange} min={value.start} aria-label="End date" data-id="element-27" />
      </div>
    </div>;
};
export default DateRangePicker;